import Http from "../../common/request";

export const getRechargeConfig = () => {
    return Http.get('/user/api/pay/recharge/findRechargeConfigList', { _loose: true })
}

export const createDiamondOrder = (configId: number, payType: number, vaultId: string, returnUrl: string, purchaseId: string) => {
    return Http.post('/user/api/pay/recharge/createOrder', { _auth: true, _json: true, configId, payType, vaultId, returnUrl, purchaseId})
}